<div class="container">
    <div class="row">
        <div class="col-md-12">
            <div class="tabbable-panel">
                <div class="tabbable-line">
                    <ul class="nav nav-tabs ">
                        <li class="nav-item">
                            <span class="mx-5">
                                <i class="fa fa-building fa-lg" aria-hidden="true"></i>
                            </span>
                            <a class="nav-link active" href="#tab_default_1" data-toggle="tab">
                                Similar Hotels
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="tab_default_1">
                            <div *ngIf="hotels" class="row">
                                <ng-container *ngFor="let hotel of hotels | slice: 0 : 5;">
                                    <div class="col-md-12 col-lg-12">
                                        <h5 class="cusromGrey">{{hotel.HotelName}} </h5>
                                        <ng-container *ngIf="hotel.StarRating">
                                            <i class="fas fa-star cusromBlue" *ngFor="let star of getStarArray(hotel.StarRating)"></i>
                                        </ng-container>
                                        <br>
                                        <p class="cusromGrey">
                                            <i class="fa fa-map-marker cusromGrey" aria-hidden="true"></i>
                                            &nbsp; {{hotel.HotelAddress}}
                                        </p>
                                    </div>
                                    <hr class="solid">
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>